module.exports = __webpack_public_path__ + "static/img/AgAABXq0GNc144mCXglEDqLnoCaUpn07.21df784.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/帽子/AgAABXq0GNc144mCXglEDqLnoCaUpn07.jpeg
// module id = Reg2
// module chunks = 0